
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Card } from 'primereact/card';
import { Carousel } from 'primereact/carousel';
import { Tag } from 'primereact/tag';
import { Chip } from 'primereact/chip';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Avatar } from "primereact/avatar";
import TrajetDisplay from '../../../mapTrajetIcons';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const apiUrl = process.env.REACT_APP_API_URL;

export const EffectueTable = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const toastRef = useRef(null);
  const idChauffeur = localStorage.getItem("idChauffeur");

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${apiUrl}IHM/api/get-courses.php?id=${idChauffeur}&effectue=1`);
        setCourses(response.data);
      } catch (error) {
        
      } finally {
        setLoading(false);
      }
    };
    if (idChauffeur) fetchCourses();
  }, [idChauffeur]);

  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === "0000-00-00") return "Non fixée";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const CourseCardTemplate = (course) => {
    const header = (
      <div
        className="flex justify-content-between align-items-center px-3 py-3 bg-faded-blue"
        style={{ backgroundColor: "#f8fafc", borderBottom: "0.1px solid #5a6264" }}
      >
        <div className="flex align-items-center gap-3">
          <Avatar
            icon="pi pi-check-circle"
            shape="circle"
            size="small"
            className="text-white shadow-1"
            style={{ backgroundColor: "#17c776" }}
          />

          <div className="flex flex-column">
            <span className="font-bold text-lg text-900 line-height-1 mb-1">
              {course.client}
            </span>
            <div className="flex gap-2 text-md">
              <Tag value={course.label_affiche} style={{ backgroundColor: "#17c776" }} />
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-lg font-medium">
            {course.prix_total - (course.paye || 0)}€
          </div>
        </div>
      </div>
    );

    return (
      <Card
        header={header}
        className="shadow-1"
        style={{
          borderRadius: "8px",
          zIndex: "1",
          width: "100%",
          fontSize: "0.5rem",
        }}
        pt={{
          body: {
            style: { padding: "0.5rem" },
          },
          content: {
            style: { padding: "0.25rem" },
          },
        }}
      >
        <div
          className="bg-gray-50 border-round-xl"
          style={{ paddingLeft: "0.7rem" }}
        >
          <div className="flex align-items-start gap-3">
            <div
              className="flex flex-column align-items-center">
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: "#4b5563",
                }}
              ></div>

              <div
                style={{
                  width: "2px",
                  height: "42px",
                  backgroundColor: "#4b5563",
                  margin: "4px 0",
                }}
              ></div>
              <i
                className="pi pi-compass text-red-500"
                style={{ fontSize: "1rem" }}
              ></i>
            </div>

            <div className="flex-1">
              <div className="mb-3">
                <div className="text-xs text-500 mb-1">Trajet</div>
                <div className="text-xs font-medium text-800">
                  <TrajetDisplay trajet={course.trajet_detail} />
                </div>
              </div>

              <div className="mb-3">
                <div className="text-xs text-500 mb-1">Ville</div>
                <div className="text-xs font-medium text-800">
                  {course.destination}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-grid gap-3">
          <div className="p-col-6">
            <Chip
              label={formatDate(course.date_depart)}
              icon="pi pi-calendar"
              className="bg-blue-50 text-xs w-full"
            />
          </div>

          <div className="p-col-6">
            <Chip
              label={course.heure?.substring(0, 5)}
              icon="pi pi-clock"
              className="bg-green-50 text-xs w-full"
            />
          </div>

          <div className="p-col-6">
            <Chip
              label={course.adresse || "Adresse non renseignée"}
              icon="pi pi-map-marker"
              className="bg-blue-50 text-xs w-full"
            />
          </div>

          <div className="p-col-6">
            <Chip
              label={`${course.nb_passagers || 1} pers.`}
              icon="pi pi-users"
              className="bg-green-50 text-xs w-full"
            />
          </div>

          <div className="p-col-6">
            <Chip
              label={`Soute : ${course.nb_bagage_soute || 0}`}
              icon="pi pi-briefcase"
              className="bg-blue-50 text-xs w-full"
            />
          </div>

          <div className="p-col-6">
            <Chip
              label={`Cabine : ${course.nb_bagage_cabine || 0}`}
              icon="pi pi-inbox"
              className="bg-green-50 text-xs w-full"
            />
          </div>

          <div className="p-col-12">
            <Chip
              label={`${course.infoSup || "Aucune"}`}
              icon="pi pi-info-circle"
              className="bg-blue-50 text-xs w-full justify-start"
            />
          </div>
        </div>
      </Card>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex align-items-center justify-content-center">
        <div className="text-center">
          <ProgressSpinner style={{ width: '50px', height: '50px' }} />
          <p className="text-600 mt-3">Chargement des courses effectués...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      <div
        style={{
          maxWidth: "1024px",
          margin: "0 auto",
          padding: "0.5rem",
        }}
      >
        {courses.length === 0 ? (
          <div className="text-center py-8">
            <div
              className="bg-gray-100 border-circle flex align-items-center justify-content-center mx-auto mb-4"
              style={{ width: "96px", height: "96px" }}
            >
              <i
                className="pi pi-map-marker text-gray-400"
                style={{ fontSize: "3rem" }}
              ></i>
            </div>
            <h3 className="text-xl font-semibold text-900 mb-2">
              Aucune course effectuée
            </h3>
            <p className="text-500">
              Vos courses terminées apparaîtront ici.
            </p>
          </div>
        ) : (
          <Carousel
            value={courses}
            itemTemplate={CourseCardTemplate}
            numVisible={1}
            numScroll={1}
            showIndicators={true}
            showNavigators={false}
            style={{ width: '100%' }}
            pt={{
              content: {
                style: { width: '100%' }
              },
              item: {
                style: { width: '100%', padding: '0' }
              },
              indicators: {
                style: {
                 
                  gap: '0.5rem'
                }
              },
              indicator: {
                style: {
                  width: '10px',
                  height: '10px',
                  clipPath:'circle(50%)',
                  backgroundColor: '#d1d5db',
                  transition: 'all 0.3s ease'
                }
              },
              indicatorButton: {
               
              }
            }}
          />
        )}
      </div>
    </div>
  );
};
